import React from 'react';
import PropTypes from 'prop-types';

import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';
import { trackV2 } from 'utils/analytics';
import { checkoutUrl } from '../../helpers.js';

import styles from './index.scss';

export class CompactFooter extends React.Component {
  handleContinueClick = () => {
    trackV2({
      category: 'summit_upsell',
      page: 'checkout',
      action: 'click',
      element: 'continue_to_billing',
      properties: {
        origin: this.props.origin,
        subscription_type: this.props.trialInfo ? 'trial' : 'organic'
      }
    });
  };

  renderPrice = () => {
    if (this.props.trialInfo) {
      return (
        <>
          <b>
            {I18n.t('strava.premium.package_select.compact_footer.trial.free')}
          </b>
          <small className={styles.note}>
            {I18n.t(
              'strava.premium.package_select.compact_footer.trial.when_billed_yearly'
            )}
          </small>
        </>
      );
    }

    return (
      <>
        <b>
          <span className={styles.amount}>
            {Cldr.formatCurrency(
              this.props.option.priceWithDiscount,
              this.props.option.currency
            )}
          </span>
          {I18n.t('strava.premium.package_select.compact_footer.per_month')}
        </b>
        <small className={styles.note}>
          {I18n.t(
            'strava.premium.package_select.compact_footer.when_billed_yearly'
          )}
        </small>
      </>
    );
  };

  renderHasSelected = () => {
    const { option, trialInfo } = this.props;

    if (trialInfo) {
      return (
        <div className={styles.summary}>
          <a
            className="btn btn-primary btn-block"
            href={checkoutUrl(option.packageIds, trialInfo)}
            onClick={this.handleContinueClick}
            data-test="continue-button"
          >
            {I18n.t('strava.premium.package_select.footer.cta_trial', {
              days: trialInfo.trialLength
            })}
          </a>
        </div>
      );
    }

    return (
      <div className={styles.summary}>
        <div className={styles.price}>{this.renderPrice()}</div>

        <a
          className="btn btn-primary"
          href={checkoutUrl(option.packageIds, trialInfo)}
          onClick={this.handleContinueClick}
          data-test="continue-button"
        >
          {I18n.t('strava.premium.package_select.compact_footer.cta_continue')}
        </a>
      </div>
    );
  };

  renderFooter = () => {
    return this.renderHasSelected();
  };

  render() {
    return <div className={styles.footer}>{this.renderFooter()}</div>;
  }
}

CompactFooter.propTypes = {
  origin: PropTypes.string.isRequired,
  option: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    packageIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    discountPercent: PropTypes.number.isRequired,
    priceWithoutDiscount: PropTypes.number.isRequired,
    priceWithDiscount: PropTypes.number.isRequired,
    allAccess: PropTypes.bool.isRequired
  }),
  trialInfo: PropTypes.shape({
    code: PropTypes.string,
    trialLength: PropTypes.number.isRequired
  })
};

CompactFooter.defaultProps = {
  option: null,
  trialInfo: null
};

export default CompactFooter;
